import type { BoardMetadata } from "../model/board.js";
import type { SearchReport } from "../model/evaluation.js";
import type { PositionRecord } from "../model/position.js";
import { evaluateBoardState } from "./evaluate.js";
import { planSuggestedActions } from "./search-planner.js";

export function buildSearchReport(
  board: BoardMetadata,
  position: PositionRecord,
  depth: number,
): SearchReport {
  const detail = evaluateBoardState(position.stateSnapshot);
  const plan = planSuggestedActions(
    board.sessionKey,
    position.stateSnapshot,
    detail,
    Math.max(1, depth),
  );

  return {
    attentionVector: detail.evaluation.attentionVector,
    candidateLines: detail.candidateLines,
    mainline: detail.mainline.map((atom) => atom.id),
    phase: detail.evaluation.phase,
    principalVariation: [position.id],
    proofs: detail.proofs,
    responses: plan.responses,
    stats: {
      attentionAtoms: detail.attentionAtoms.length,
      attentionCells: detail.attentionCells.length,
      exploredBranches: Math.max(plan.stats.exploredBranches, plan.responses.length),
      searchedDepth: depth,
      transpositionHits: plan.stats.transpositionHits,
      visitedNodes: plan.stats.visitedNodes,
    },
    threats: detail.threats,
  };
}
